import styled, { css } from "styled-components";
import { hex2rgba } from "../../utils/styles";

export const StyledPaper = styled.div`
    display: ${({ inline }) => inline ? 'inline-block' : 'block'};
    background-color: ${({ theme, backgroundColor }) => backgroundColor ? backgroundColor : theme.colors.white};
    padding: 20px 40px;
    border-radius: 10px;
    box-shadow: 0px 0px 2px 0px ${({ theme }) => hex2rgba(theme.colors.black, 0.16)};
    ${({ noShadow }) => noShadow && css`
        box-shadow: none;
    `};
    ${({ customStyle }) => customStyle && customStyle};
`;